import React, { RefObject, useEffect, useRef } from 'react';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { ISuggestionItem, FilterType, SessionState } from './ISearch';
import Looks3Icon from '@material-ui/icons/Looks3';

import './../../styles/css/search.css';
import { convertStatusToSlovenian } from '../../shared/helpers';
interface IProps {
  suggestions: ISuggestionItem[];
  shown: boolean;
  activeIndex: number;
  forwardRef: RefObject<HTMLDivElement>;
  clickCallback: (index: number) => void;
  hoverCallback: (index: number) => void;
  canSearch: boolean;
  text: string;
  filteringSessionsState: boolean;
}

const SuggestionDropdown = ({
  suggestions,
  shown,
  activeIndex,
  forwardRef,
  clickCallback,
  hoverCallback,
  canSearch,
  text,
  filteringSessionsState
}: IProps) => {

  const wasMouseMoved = useRef<boolean>(false);
  const activeIndexLocal = useRef<number>(-1)

  const onMouseEnter = (index: number) => {
    activeIndexLocal.current = index
    if (wasMouseMoved.current) hoverCallback(index)
  }

  useEffect(() => {
    if (!shown) {
      wasMouseMoved.current = false;
    }
  }, [shown])

  const mouseMovedCallback = () => {
    if (activeIndexLocal.current !== activeIndex) hoverCallback(activeIndexLocal.current)
    wasMouseMoved.current = true;
  }

  const onMouseLeaveDropdown = () => onMouseEnter(-1)

  return (

    <div onMouseMove={mouseMovedCallback} onMouseLeave={onMouseLeaveDropdown} className={`suggestions ${shown ? 'active' : ''}`} ref={forwardRef}>
      {canSearch && text !== '' && (
        <div
          className={`suggestions-item ${activeIndex === -1 ? 'active' : ''}`}
          onMouseEnter={() => onMouseEnter(-1)}
          onClick={() => clickCallback(-1)}
        >
          <SearchIcon fontSize="small" style={{ padding: '1px' }}></SearchIcon>
          <span className="suggestions-item-label">Išči '{text}'</span>
        </div>
      )}
      {suggestions.map((sug: ISuggestionItem, index: number) => (
        <div
          key={index}
          className={`suggestions-item ${activeIndex === index ? 'active' : ''}`}
          onMouseEnter={() => onMouseEnter(index)}
          onClick={() => clickCallback(index)}
        >
          <FilterIcon filterType={sug.nextType} />
          <span className="suggestions-item-label"> {filteringSessionsState ? convertStatusToSlovenian(sug.label as SessionState) : sug.label} </span>
          {/* <span className="suggestions-item-field"> {sug.field} </span> */}
        </div>
      ))}
    </div>
  );
};

interface IPropsIcon {
  filterType: FilterType;
}

const FilterIcon = ({ filterType }: IPropsIcon) => {
  switch (filterType) {
    case FilterType.NumberFilter:
      return <Looks3Icon fontSize="small" style={{ padding: '1px' }} />;
    case FilterType.StringFilter:
      return <TextFieldsIcon fontSize="small" style={{ padding: '1px' }} />;
    case FilterType.DateFilter:
      return <CalendarTodayIcon fontSize="small" style={{ padding: '1px' }} />;
    default:
      return <FilterListIcon fontSize="small" style={{ padding: '1px' }} />;
  }
};

export default SuggestionDropdown;
